import React from 'react';
import classes from './style.module.scss';
import { WorkOrderTaskPartList } from '~/workorder/types';
import useTranslation from '~/app/hooks/useTranslation';
import Icon from '~/app/common/Icon';

export type PartsComponent = React.FC<{ parts: WorkOrderTaskPartList[]}>;

const Parts: PartsComponent = ({ parts }) => {
    const { t } = useTranslation('workorder');
    const { t: tParts } = useTranslation('parts');

    return (
        <div className={classes.card}>
        <div className={classes['section-header']}>
            <h2 className={classes['section-header-title']}>
                <Icon name="build" size={20} className={classes['section-header-icon']} />
                {tParts('parts')}
            </h2>
        </div>
        {parts.length === 0 ? (
            <p className={classes.empty}>{t('detail.noParts')}</p>
        ) : (
            <div className={classes.list}>
                {parts.map(part => (
                    <div key={part.id} className={classes['list-row']}>
                        <div className={classes['row-main']}>
                            <p className={classes['row-name']}>{part.name}</p>
                        </div>
                        <div className={classes['row-actions']}>
                            <span className={classes['row-quantity']}>
                                {part.quantity} {tParts('item')}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        )}
    </div>
    );
}

export default Parts;